import {
  ATTRIBUTION_MODEL,
  GRANULARITY,
} from '@adtrackify/at-tracking-event-types';

export const GRANULARITY_MAP: Record<string, GRANULARITY> = {
  [GRANULARITY.DAY]: GRANULARITY.DAY,
  [GRANULARITY.HOUR]: GRANULARITY.HOUR,
  [GRANULARITY.WEEK]: GRANULARITY.WEEK,
  [GRANULARITY.MONTH]: GRANULARITY.MONTH,
  [GRANULARITY.QUARTER]: GRANULARITY.QUARTER,
  [GRANULARITY.YEAR]: GRANULARITY.YEAR,
};

export const DEFAULT_ATTRIBUTION_MODELS_MAP: Record<string, ATTRIBUTION_MODEL> = {
  [ATTRIBUTION_MODEL.FIRST_CLICK]: ATTRIBUTION_MODEL.FIRST_CLICK,
  [ATTRIBUTION_MODEL.LAST_CLICK]: ATTRIBUTION_MODEL.LAST_CLICK,
  [ATTRIBUTION_MODEL.ANY_CLICK]: ATTRIBUTION_MODEL.ANY_CLICK,
};

export const DEFAULT_COMPARE_PRESET = 'previousPeriod';

export const FILTER_DEBOUNCE_MS = 200;
